import React, { useState } from 'react';
import { getCurrentUser, getCookie } from '../../functions/utils';

const TestEnvironment = () => {
  const [divisionId, setDivisionId] = useState('');
  const [glSchemeCode, setGlSchemeCode] = useState('RGS versie 3.2');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function fetchRGS() {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const currentUser = await getCurrentUser();
      const division = divisionId || getCookie('current_division');
      const params = new URLSearchParams({
        divisionId: division,
        currentUser: currentUser,
      });
      if (glSchemeCode) params.append('glSchemeCode', glSchemeCode);

      const response = await fetch('/exactonline/rgs?' + params.toString());
      if (!response.ok) throw new Error('HTTP ' + response.status);
      const data = await response.json();
      setResult(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      <h3>Exact Online RGS Test</h3>
      <div style={{ marginBottom: '10px' }}>
        <label>Division ID: </label>
        <input
          value={divisionId}
          onChange={(e) => setDivisionId(e.target.value)}
          placeholder={getCookie('current_division') || 'division id'}
          style={{ marginLeft: '5px', width: '200px' }}
        />
      </div>
      <div style={{ marginBottom: '10px' }}>
        <label>GL Scheme Code: </label>
        <input
          value={glSchemeCode}
          onChange={(e) => setGlSchemeCode(e.target.value)}
          style={{ marginLeft: '5px', width: '200px' }}
        />
      </div>
      <button className="import-btn hover" onClick={fetchRGS} disabled={loading}>
        {loading ? 'Loading...' : 'Fetch RGS Mappings'}
      </button>

      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {result && (
        <div style={{ marginTop: '15px' }}>
          <p>{result.results ? result.results.length : 0} mappings found</p>
          <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '13px' }}>
            <thead>
              <tr>
                <th style={thStyle}>GLAccountCode</th>
                <th style={thStyle}>GLAccountDescription</th>
                <th style={thStyle}>ClassificationCode</th>
                <th style={thStyle}>ClassificationDescription</th>
              </tr>
            </thead>
            <tbody>
              {result.results && result.results.map((row, i) => (
                <tr key={i}>
                  <td style={tdStyle}>{row.GLAccountCode}</td>
                  <td style={tdStyle}>{row.GLAccountDescription}</td>
                  <td style={tdStyle}>{row.ClassificationCode}</td>
                  <td style={tdStyle}>{row.ClassificationDescription}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const thStyle = { border: '1px solid #ccc', padding: '4px 8px', textAlign: 'left', background: '#f5f5f5' };
const tdStyle = { border: '1px solid #ccc', padding: '4px 8px' };

export default TestEnvironment;
